import { render, staticRenderFns } from "./AdditionalFieldsTable.vue?vue&type=template&id=0f9b8bd2&scoped=true&"
import script from "./AdditionalFieldsTable.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9b8bd2",
  null
  
)

export default component.exports